module.exports = __webpack_public_path__ + "img/202309_04.c64bf502.jpg";